var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"edit-button",style:(_vm.butStyle),attrs:{"icon":"edit","size":"sm"},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }